export const legalConfigCodes = {
  us: {
    // for country code US
    tnc: 'TNC_AGREEMENT',
    buy_tnc: 'BUY_NOW_TNC_AGREEMENT',
    data: 'TNC_AGREE_DATA_SHARE',
    subscription: 'TNC_SUBSCRIPTION_PURCHASE',
    claim: 'WARRANTY_VOID_CLAIM',
    wipe: 'TNC_WIPE_DATA',
  },
  tr: {
    // for country code TR
    tnc: 'TNC_AGREEMENT_CONSUMER_APP_OTP',
    data: 'TNC_AGREE_DATA_SHARE',
  },
  other: {
    // list of consents generic to other countries
    tnc: 'TNC_AGREEMENT',
    buy_tnc: 'BUY_NOW_TNC_AGREEMENT',
    data: 'TNC_AGREE_DATA_SHARE',
    tnc_insurance: 'TNC_AGREE_INSURANCE',
    buy_tnc_gst_credit_na: 'BUY_NOW_TNC_GST_CREDIT_NA',
    payment_decl: 'PAYMENT_DECLARATION_WEB',
    payment_decl2: 'PAYMENT_DECL_WEB', // this is without [other related documents]
    multi_device: 'CW_MULTI_DEVICE_CONSENT',
  },
}

export const getLegalConsents = (legalConfigs, consentIDs) => {
  return (
    (legalConfigs.length &&
      legalConfigs.filter(
        (config) =>
          config.legalConfig && config.legalConfig.legalConfigCode && consentIDs.indexOf(config.legalConfig.legalConfigCode) !== -1
      )) ||
    []
  )
}

// Checks if the consent is available in the legal config list
export const hasConsent = (legalConfigs, consentID) => {
  let consent = legalConfigs.find((config) => config.legalConfig && config.legalConfig.legalConfigCode === consentID)
  return !!consent
}

export const getConsentTextChunks = (consentText) => {
  if (consentText?.length && consentText.indexOf('@') !== -1) return consentText.split(/([@][a-zA-Z]+[@])/g)
  return ''
}

export const consentLabels = {
  aboutUs: { key: 'aboutUs', route: 'about-us', value: 'aboutUs' },
  tnc: { key: 'termsAndCondition', route: 'terms-conditions', value: 'terms' },
  privacy: { key: 'privacyPolicy', route: 'privacy-policy', value: 'privacy' },
  dataconsent: { key: 'dataConsent', route: 'online-consent', value: 'consentURL' },
  dataconsentstore: { key: 'dataConsent', route: 'online-consent', value: 'consentURL' },
  insurancecard: { key: 'insuranceCard' },
  relateddocuments: { key: 'relateddocuments' },
  country: { key: 'country' },
  ipid: { key: 'IPID' },
  infoInsuranceIntermediary: { key: 'infoInsuranceIntermediary' },
  infoToCustomers: { key: 'infoToCustomers' },
}

export const legalConfigAttributes = {
  email: 'EmailID',
  imei_serial: 'imeiOrSerial',
  privacy: 'PrivacyPolicyLink',
  tnc: 'TermsAndConditionsLink',
  ipid: 'IPIDLink',
  insurancecard: 'IPIDLink',
  relateddocuments: 'OtherRelatedDocumentsLink',
  dataconsent: 'ConsentURL',
  otp: 'OTP',
  country: 'country',
}

export const getPlaceholders = (consentText) => {
  let chunks = getConsentTextChunks(consentText)
  if (chunks.length) {
    let placeholders = []
    chunks.forEach((chunk) => {
      if (chunk[0] === '@' && chunk[chunk.length - 1] === '@') {
        placeholders.push(chunk.replace(/@/g, ''))
      }
    })
    return placeholders
  }
  return []
}

export const replacePlaceholders = (consent, countryName, translatedData, planDocuments, appConfigDetails) => {
  return getConsentTextChunks(consent)
    .map((chunk) => {
      if (chunk[0] === '@' && chunk[chunk.length - 1] === '@') {
        let link = chunk.replace(/@/g, '')
        if (link === 'country') {
          return translatedData.common[`localized${countryName?.replaceAll(' ', '')}`] || countryName
        }
        return (
          (planDocuments && planDocuments[chunk]?.planDocumentDisplayText) ||
          (appConfigDetails?.consents && appConfigDetails?.consents?.[chunk]?.consentDisplayText) ||
          consent
            ?.replaceAll('@tnc@', translatedData.common.termsAndCondition)
            ?.replaceAll('@privacy@', translatedData.common.privacyPolicy)
            ?.replaceAll('@dataconsent@', translatedData.common.dataConsent)
            ?.replaceAll('@insurancecard@', translatedData.store.insuranceCard)
            ?.replaceAll('@relateddocuments@', translatedData.store.relateddocuments)
        )
      }
      return chunk
    })
    .join('')
}

export const getConsentPlaceholders = (consent) => {
  const chunks = getConsentTextChunks(consent)
  return chunks.filter((chunk) => chunk[0] === '@' && chunk[chunk.length - 1] === '@')
}
